export const employeeListRoute = {
  path: "/management/user",
  name: "user-list",
  component: () => import("@/ui/management/user/user-list.vue")
};